import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-external-link',
  templateUrl: './external-link.component.html',
  styleUrls: ['./external-link.component.scss']
})
export class ExternalLinkComponent {

  @Input() externalUrl:string;
  @Input() windowName = '_blank';



  navigateToUrl(){
    
    let url = this.externalUrl;
    if(!url){
      return false;
    }

    url = url.match(/^http[s]?:\/\//) ? url : 'https://' + url;
    window.open(url,this.windowName);
  }

}
